import styled, { css, keyframes } from 'styled-components';
import { palette, key } from 'styled-theme';

import { media } from '../../../helper/styleHelper';

import Button from '../button';
import Label from '../label';
import { CloseIconRed } from '../../icons';

export const StyledEmbedModal = styled.div`
  display: ${(props) => (props.isOpen ? 'grid' : 'none')};
  position: fixed;
  z-index: 100;
  left: 0;
  top: ${key('sizes.gutter.medium', '60px')};
  width: 100%;
  height: 100%;
  background: ${palette('background', 0)};

  ${(props) =>
    props?.scrollModal
      ? css`
          overflow: auto;
        `
      : css``}
`;

const animatetop = keyframes`
from {top:-300px; opacity:0;}
to {top:0; opacity:1;}
`;

export const StyledModalContent = styled.div`
  margin: 20px;
  position: relative;
  border-radius: ${key('sizes.gutter.normal', '4px')};

  ${media.sm`
  margin: auto;
  `}
  padding: 0;
  width: fit-content;
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: ${animatetop};
  -webkit-animation-duration: 0.4s;
  animation-name: ${animatetop};
  animation-duration: 0.4s;
`;

export const ModalBody = styled.div``;

export const ModalBodyContainter = styled.div`
  position: relative;
  background: ${palette('background', 0)};
  box-shadow: 0px 0px 30px #0071e329;

  border-radius: ${key('sizes.borderRadius.normal', '4px')};
  // width: fit-content;
  width: 100%;
  height: fit-content;
  max-height: auto;

  ${(props) =>
    props.overFlowVisible
      ? css``
      : css`
          overflow-y: auto;
        `}

  ${(props) =>
    props?.color === 'primary'
      ? css`
          border: 1px solid ${palette('border', 0)};
          box-shadow: 0px 0px 30px ${palette('shadow', 0)};
        `
      : props?.color === 'warning'
      ? css`
          border: 1px solid ${palette('error', 0)};
          box-shadow: 0px 0px 30px ${palette('shadow', 0)};
        `
      : css`
          border: 1px solid ${palette('primary', 0)};
          box-shadow: 0px 0px 30px ${palette('shadow', 0)};
        `}

  ${media.xxl`
    width: 100%;
    height: fit-content;
    max-height: auto;
    ${(props) =>
      props.overFlowVisible
        ? css``
        : css`
            overflow-y: auto;
          `}
  `}
`;

export const StyledModal = styled.div`
  display: ${(props) => (props.isOpen ? 'grid' : 'none')};
  justify-content: center;
  align-items: center;

  position: fixed;
  z-index: 999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(1, 1, 1);
  background-color: rgba(1, 1, 1, 0.2);
`;

export const StyledChildModal = styled.div`
  display: ${(props) => (props.isOpen ? 'grid' : 'none')};
  justify-content: center;
  align-items: center;

  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(1, 1, 1);
  background-color: rgba(1, 1, 1, 0.2);
`;

export const ModalHeader = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;

  padding: 20px;
  padding-bottom: 10px;

  ${media.sm`
  padding: 20px;
  padding-bottom: 20px;
  `}
  ${media.xlr`
  padding: 20px;
  padding-bottom: 20px;
  `}
  ${media.xxl`
  padding: 24px;
  padding-bottom: 20px;
  `}
  ${media.vxxl`
  padding: 26px;
  padding-bottom: 20px;
  `}
`;

export const ModalTitle = styled(Label)`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: ${key('sizes.gutter.5', '5px')};
  font: normal normal bold 18px/14px Space Grotesk Bold;
  ${(props) =>
    props.isNotCapitalize
      ? css`
          text-transform: normal;
        `
      : css`
          text-transform: capitalize;
        `}
  ${(props) =>
    props.isUppercase &&
    css`
      text-transform: uppercase;
    `}

  letter-spacing: 0px;

  ${(props) =>
    props?.color === 'primary'
      ? css`
          color: ${palette('text', 4)};
        `
      : props?.color === 'warning'
      ? css`
          color: ${palette('error', 0)};
        `
      : css`
          color: ${palette('text', 4)};
        `}
`;

export const CloseButton = styled.button`
  :hover {
    box-sizing: border-box;
    background-color: ${palette('gray', 0)};
    padding: 10px;
    margin: -10px;
  }
`;

export const ModalSubmitButton = styled(Button)`
  display: fixed;
  bottom: 0;
  width: 100%;
  border-radius: 0px 0px 4px 4px;
  height: ${key('sizes.embedModalButton.tiny', '50px')};
  font-size: ${key('sizes.font.normal', '14px')};
  margin-top: 0px;
  ${media.xxl`
          height: ${key('sizes.embedModalButton.small', '65px')};
          font-size: ${key('sizes.xxlFont.normal', '16px')};
          `}
`;
export const Img = styled.img`
  height: ${key('sizes.gutter.22', '22px')};
  width: ${key('sizes.gutter.22', '22px')};
`;

export const CloseIconRedNew = styled(CloseIconRed)`
  height: 12px;
  width: 12px;
  cursor: pointer;
  ${media.xxl`
  width: 13px;
  height: 13px;
  `}
  ${media.vxxl`
  width: 14px;
  height: 14px;
  `}
`;
